module.exports = __webpack_public_path__ + "img/icx.8fad20c1.svg";